module.exports = __webpack_public_path__ + "static/examp3-f04151eb95c6b9e41c00c0e7b1e3cbab.gif";